// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7429f2655a0fcd682f34","883":"1a3f2c4b81de8369e839"}[chunkId] + ".js";
};